<template>
  <div style="padding: 0 16px">
    <a-skeleton :loading="spinning" active>
      <a-table :columns="columns" :pagination="pagination" :data-source="changelogs" size="small" row-key="index" @change="handleTableChange">
        <span slot="number" slot-scope="record">{{ record.index }}</span>
        <span slot="operator" slot-scope="operator">{{ operator ? operator.nickname : '系统' }}</span>
        <span slot="diffItem" slot-scope="record">
          <div v-for="(item, key) in record.value_diff" :key="key">{{ item.label }}</div>
        </span>
        <span slot="before" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="['name', 'project_id'].includes(item.value)">{{ item.before || '--' }}</div>
              <div v-else-if="item.value === 'requirement_id'">
                <a v-if="item.before" :href="link(item.after)" target="_blank">{{ item.before }}</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'status'">
                <a-badge v-if="item.before !== null && caseStatus[item.before]" :status="caseStatus[item.before].status" :color="caseStatus[item.before].color" :text="caseStatus[item.before].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'priority'">
                <a-tag v-if="item.before" :color="casePrioritys[item.before].color"> {{ casePrioritys[item.before].label }} </a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'premium'">
                <a-tag v-if="item.before !== null" :color="casePremiums[item.before].color"> {{ casePremiums[item.before].label }} </a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'tags'">
                <a-tag v-for="(tag, index) in item.before" :key="index" color="blue">{{ tag.name }}</a-tag>
              </div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.before !== null" @click="onPreview(item.before, '「变更前」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'precondition'">
                <a v-if="item.before !== null" @click="onPreview(item.before, '「变更前」前置条件')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'steps'">
                <a v-if="item.before !== null" @click="onStepPreview(item.before, '「变更前」操作步骤')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'ai_score'">
                <a v-if="item.before !== null" @click="onAiScoreLogPreview(item.before, '「变更前」评分标准')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
        <span slot="after" slot-scope="record">
          <span>
            <span v-for="(item, key) in record.value_diff" :key="key">
              <div v-if="['name', 'project_id'].includes(item.value)">{{ item.after || '--' }}</div>
              <div v-else-if="item.value === 'requirement_id'">
                <a v-if="item.after" :href="link(item.after)" target="_blank">{{ item.after }}</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'status'">
                <a-badge v-if="item.after && caseStatus[item.after]" :status="caseStatus[item.after].status" :color="caseStatus[item.after].color" :text="caseStatus[item.after].label" />
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'priority'">
                <a-tag v-if="item.after" :color="casePrioritys[item.after].color"> {{ casePrioritys[item.after].label }} </a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'premium'">
                <a-tag v-if="item.after !== null" :color="casePremiums[item.after].color"> {{ casePremiums[item.after].label }} </a-tag>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'tags'">
                <a-tag v-for="(tag, index) in item.after" :key="index" color="blue">{{ tag.name }}</a-tag>
              </div>
              <div v-else-if="item.value === 'description'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」描述')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'precondition'">
                <a v-if="item.after !== null" @click="onPreview(item.after, '「变更后」前置条件')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'steps'">
                <a v-if="item.after !== null" @click="onStepPreview(item.after, '「变更后」操作步骤')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else-if="item.value === 'ai_score'">
                <a v-if="item.after !== null" @click="onAiScoreLogPreview(item.after, '「变更后」评分标准')">查看详情</a>
                <span v-else>--</span>
              </div>
              <div v-else>--</div>
            </span>
          </span>
        </span>
      </a-table>
    </a-skeleton>
    <preview-modal ref="previewModal" />
    <case-step-modal ref="caseStepModal" />
    <ai-score-log-view-modal ref="aiScoreLogViewModal" />
  </div>
</template>

<script>
import { caseRecord } from '@/api/project/case';
import { caseStatus, casePrioritys, casePremiums } from '@/utils/dictionary';

import PreviewModal from '@/pages/project/components/PreviewModal';
import CaseStepModal from '@/pages/project/case/components/CaseStepModal';
import AiScoreLogViewModal from '@/pages/project/case/components/AiScoreLogViewModal';

const columns = [
  {
    title: '序号',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: '10%',
    align: 'center',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: '15%',
    align: 'center',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: '10%',
    align: 'center',
    key: 'operation_alias',
    dataIndex: 'operation_alias'
  },
  {
    title: '变更项',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'diffItem' }
  },
  {
    title: '变更前',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'before' }
  },
  {
    title: '变更后',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'after' }
  }
];
export default {
  components: { PreviewModal, CaseStepModal, AiScoreLogViewModal },
  props: {
    sourceId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      caseStatus,
      casePremiums,
      casePrioritys,
      spinning: true,
      projectId: parseInt(this.$route.params.project_id) || null,
      changelogs: [],
      pagination: {
        size: 'small',
        total: 0,
        pageSize: this.$store.getters.pageSize, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      changelogItems: {
        tags: { value: 'tags', label: '标签' },
        name: { value: 'name', label: '名称' },
        steps: { value: 'steps', label: '步骤' },
        status: { value: 'status', label: '状态' },
        premium: { value: 'premium', label: '优质用例' },
        priority: { value: 'priority', label: '优先级' },
        description: { value: 'description', label: '描述' },
        precondition: { value: 'precondition', label: '前置条件' },
        requirement_id: { value: 'requirement_id', label: '关联需求' },
        ai_score: { value: 'ai_score', label: 'AI评分' },
        project_id: { value: 'project_id', label: '项目' }
      }
    };
  },
  computed: {
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(this.changelogItems);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...this.changelogItems[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    },
    link() {
      return value => {
        return this.$router.resolve({
          name: 'page:project:story:detail',
          query: { storyId: value }
        }).href;
      };
    }
  },
  watch: {
    sourceId: {
      handler: 'getCaseChangelog',
      immediate: true
    }
  },
  created() {
    this.getCaseChangelog();
  },
  methods: {
    getCaseChangelog() {
      caseRecord({
        case_id: this.sourceId,
        project_id: this.projectId,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.pagination.total = res.data.total;
          this.changelogs = res.data.items.map((changelog, index) => {
            return {
              index: index + 1,
              ...changelog,
              value_diff: this.diff(changelog.value_diff)
            };
          });
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },

    onPreview(content, title = null) {
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, title);
      });
    },
    onStepPreview(step, title = null) {
      this.$nextTick(() => {
        this.$refs.caseStepModal.onOpen(step, title);
      });
    },
    onAiScoreLogPreview(aiScore, title = null) {
      this.$nextTick(() => {
        this.$refs.aiScoreLogViewModal.onOpen(aiScore, title);
      });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getCaseChangelog();
    }
  }
};
</script>
<style lang="less" scoped>
.diff-item {
  display: block;
}

.ql-container.ql-snow {
  border: none;
}
</style>
